import { config } from "/app.config"

export default [
  {
    path: "advertising",
    name: "advertising",
    component: () => import("@/views/Advertising/Advertising"),
    meta: {
      pageTitle: config.isSurferNetwork ? "Campaigns" : "Advertising",
      rule: "owner",
    },
    redirect: { name: "campaigns" },
    children: [
      {
        path: "campaigns",

        component: () => import("@/views/Advertising/Campaigns"),
        children: [
          {
            path: "",
            name: "campaigns",
            component: () => import("@/views/Advertising/components/CampaignList"),
            meta: {
              pageTitle: "Campaigns",
              parent: "advertising",
              rule: "owner",
            },
          },
          {
            path: "create",
            name: "campaign.create",
            component: () => import("@/views/Advertising/CampaignCreate"),
            meta: {
              pageTitle: "Create Campaign",
              parent: "advertising",
              rule: "owner",
            },
          },
          {
            path: ":campaignId/edit",
            name: "campaign.edit",
            component: () => import("@/views/Advertising/CampaignEdit"),

            meta: {
              pageTitle: "Edit Campaign",
              parent: "advertising",
              rule: "owner",
            },
          },
          {
            path: ":campaignId/report",
            name: "campaign.report",
            component: () => import("@/views/Advertising/components/CampaignReport"),

            meta: {
              pageTitle: "Campaign Report",
              parent: "advertising",
              rule: "owner",
            },
          },
        ],
      },
    ],
  },
]
